const updateUserProfile = (profileData) => {
  localStorage.setItem("userProfile", JSON.stringify(profileData));
  // Dispatch custom event
  window.dispatchEvent(
    new CustomEvent("userProfileUpdated", {
      detail: profileData,
    })
  );
};

export { updateUserProfile };
